module.exports = __webpack_public_path__ + "static/FutureOfTransport_p4.90583a8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FutureOfTransport/FutureOfTransport_p4.png
// module id = 521
// module chunks = 202548274545758